import React, { createContext, useContext } from 'react';

const ThemeContext = createContext({ theme: 'light' });

export const useTheme = () => useContext(ThemeContext);

/**
 * Theme is permanently set to 'light' (antique beige).
 * Dark mode has been removed per design decision.
 */
export const ThemeProvider = ({ children }) => (
  <ThemeContext.Provider value={{ theme: 'light' }}>
    {children}
  </ThemeContext.Provider>
);
